import actions from '../../actionTypes';

export default workflow => {
  return {
    type: actions.EDIT_WORKFLOW,
    workflow
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/editWorkflow.js